module.exports = __webpack_public_path__ + "static/media/mo.ffdadb73.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mo.svg
// module id = 2158
// module chunks = 0